import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { CSSTransition } from 'react-transition-group';

import { IconButton } from '@bibliocommons/base-buttons';
import { ChevronDown, ChevronRight } from '@bibliocommons/base-icons';

import ContextMenu from './shared/ContextMenu';

import './Section.scss';

const Section = ({
  children,
  className,
  heading,
  isExpanded,
  onDelete,
  onIsExpandedToggle,
  pageName,
  renderReOrderButtons,
  sectionId
}) => {
  const confirmDeleteModalMessage = `Are you sure you want to delete the '${heading}' section on the '${pageName}' page?`;

  const toggleIsExpanded = () => {
    onIsExpandedToggle(sectionId);
  };

  const toggleButtonKey = `${sectionId}_ToggleButtonKey`;

  return (
    <section className={cn('cp-browse-admin-home-section', className)}>
      <div className="heading-wrapper">
        <IconButton dataKey={toggleButtonKey} handleClick={toggleIsExpanded} type="button">
          {isExpanded ? <ChevronDown /> : <ChevronRight />}
        </IconButton>
        <h3 className="heading">{heading}</h3>
        <div className="actions">
          {renderReOrderButtons()}
          <ContextMenu
            className="action-context-menu"
            confirmDeleteModalHeading="Delete section"
            confirmDeleteModalMessage={confirmDeleteModalMessage}
            onDeleteClick={onDelete}
          />
        </div>
      </div>
      <CSSTransition in={isExpanded} classNames="fade" timeout={{ enter: 150, exit: 75 }} mountOnEnter unmountOnExit>
        <div className="body">{children}</div>
      </CSSTransition>
    </section>
  );
};

Section.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  heading: PropTypes.string.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  onDelete: PropTypes.func.isRequired,
  onIsExpandedToggle: PropTypes.func.isRequired,
  pageName: PropTypes.string.isRequired,
  renderReOrderButtons: PropTypes.func.isRequired,
  sectionId: PropTypes.string.isRequired
};

export default Section;
